<div class="topbar">
  <div class="topbar-breadcrumbs">
    @if (breadcrumbs | async; as $breadcrumbs) {
      <div>
        @for (breadcrumb of $breadcrumbs; track breadcrumb; let i = $index) {
          @if (i > 0) {
            <span class="topbar-breadcrumbs-separator">‣</span>
          }
          @if (i < $breadcrumbs.length - 1) {
            <user-interaction [interaction]="breadcrumb.userInteraction" class="topbar-breadcrumbs-interaction">
              <span [innerText]="breadcrumb.label" ></span>
            </user-interaction>
          }
          @if (i === $breadcrumbs.length - 1) {
            <strong [innerText]="breadcrumb.label"></strong>
          }
        }
      </div>
    }
  </div>
  <nav class="topbar-meta_menu">
    <ul>
      @for (navigationItem of metaMenuItems | sort:'order'; track navigationItem) {
        <li
          class="topbar-meta_menu-item">
          @if (!navigationItem.children?.length) {
            <user-interaction [interaction]="navigationItem.userInteraction"
              [matTooltip]="navigationItem.label"
              matTooltipPosition="below"
              >
              <span class="topbar-meta_menu-item-icon">
                <span [ngClass]="navigationItem.icon"></span>
              </span>
            </user-interaction>
          }
          @if (navigationItem.children?.length) {
            <hls-menu align="right">
              <hls-icon [icon]="navigationItem.icon"
                slot="toggle"
                [matTooltip]="navigationItem.label"
              matTooltipPosition="below"></hls-icon>
              @for (childNavigationItem of navigationItem.children; track childNavigationItem) {
                <div slot="entry">
                  <user-interaction [interaction]="childNavigationItem.userInteraction">
                    <hls-icon [icon]="childNavigationItem.icon"></hls-icon>
                    <span [innerText]="childNavigationItem.label"></span>
                  </user-interaction>
                </div>
              }
            </hls-menu>
          }
        </li>
      }
    </ul>
  </nav>
</div>
